var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconOtherHousingDevelopments(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45.85 45.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-other-housing-developments") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.92,0A22.93,22.93,0,1,0,45.85,22.92,22.92,22.92,0,0,0,22.92,0Zm0,40.56A17.64,17.64,0,1,1,40.56,22.92,17.65,17.65,0,0,1,22.92,40.56Z",
    fill: "#ff54ac"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13,32.9l13.72-6.23L32.9,13,19.19,19.18Zm12.47-7.48-10,5,5-10Z",
    fill: "#ff54ac"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOtherHousingDevelopments);
export default __webpack_public_path__ + "static/media/icon-other-housing-developments.ac355bdd27f85c317e637ac3340a28eb.svg";
export { ForwardRef as ReactComponent };